<div class="sensors" [nbSpinner]="showSpinner()">
  @let currentSensorBlocks = sensorBlocks();
  @for (sensorBlock of currentSensorBlocks; track sensorBlock.id) {
    <wr-sensor-block-item [sensorBlockItem]="sensorBlock" (refreshed)="onRefresh()"></wr-sensor-block-item>
  }
</div>
@if(canEditSensors()) {
  <div class="add-sensor-block" (click)="addNewSensorBlock()" [nbTooltip]="'Neuen Sensorblock hinzufügen'">
    <nb-icon pack="eva" icon="plus-outline"></nb-icon>
  </div>
}
